module.exports = __webpack_public_path__ + "img/outfit_change3.44596153.png";